<h1 mat-dialog-title class="p-2 text-center">Conformité de la zone</h1>
<div mat-dialog-content class="p-3">
    <div class="row">
        <mat-form-field class="col">
            <mat-label>MPCA</mat-label>
            <mat-select placeholder="MPCA" [(ngModel)]="SelectedMPCAList" [compareWith]="compareWith" multiple>
                @for (mpca of Model?.MpcaList; track mpca) {
                <mat-option [value]="mpca">
                    {{ mpca.Name }} {{ getDegradationLevelName(mpca.DegradationLevel) }}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
    <div class="row">
        <mat-form-field class="col">
            <mat-label>Type de bâtiment</mat-label>
            <mat-select placeholder="Type de bâtiment" [(ngModel)]="Model.BuildingType">
                @for (b of BuildingTypeList; track b; let i = $index) {
                <mat-option [value]="i + 1">
                    {{ b }}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <div class="row">
        <mat-form-field class="col">
            <mat-label>Usage du local</mat-label>
            <mat-select placeholder="Usage du local" [(ngModel)]="Model.RoomUsage">
                @for (u of UsageList; track u; let i = $index) {
                <mat-option [value]="i + 1">
                    {{ u }}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <div class="row">

        <mat-form-field class="col">
            <mat-label>Type de protection de la zone</mat-label>
            <input placeholder="Type de protection de la zone" [matAutocomplete]="onSiteProtectionAndSealingTypeAuto" type="text" [(ngModel)]="Model.OnSiteProtectionAndSealingType" matInput>
            <mat-autocomplete #onSiteProtectionAndSealingTypeAuto="matAutocomplete">
                @for (protection of ProtectionList; track protection) {
                <mat-option [value]="protection">
                    {{protection}}
                </mat-option>
                }
            </mat-autocomplete>
            <!-- <mat-error *ngIf="zoneFormGroup.get('on_site_protection_and_sealing_type').hasError('required')">
      Sélectionner une valeur
    </mat-error> -->
        </mat-form-field>
    </div>

    <div class="row">
        <mat-form-field class="col">
            <mat-label>Type de simulation d'activité</mat-label>
            <mat-select placeholder="Type de simulation d'activité" [(ngModel)]="Model.ActivitySimulation">
                @for (u of SimulationTypeList; track u; let i = $index) {
                <mat-option [value]="i + 1">
                    {{ u }}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <!-- <div class="row">
<mat-form-field class="col">
  <mat-select placeholder="Etat de dégradation" [(ngModel)]="Model.DegradationLevel">
    <mat-option *ngFor="let d of DegradationLevelList; let i = index" [value]="i + 1">
      {{ d }}
    </mat-option>
  </mat-select>
</mat-form-field>
</div> -->

    <div class="row">
        <mat-form-field class="col">
            <mat-label>Observation</mat-label>
            <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" [(ngModel)]="Model.Observation" placeholder="Observation"></textarea>
        </mat-form-field>
    </div>
    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1" color="accent" mat-raised-button (throttledClick)="onConfirm()">
            Valider
        </button>
    </div>
</div>